import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CarAllocation } from '../types/carAllocation';

export const ConfirmAllocationTaskDeletionSlice = createSlice({
  name: 'confirmAllocationDeletion',
  initialState: {
    allocationId: null,
    goesStraight: null,
  } as { allocationId: number | null; goesStraight?: boolean | null },
  reducers: {
    registerAllocationIdToDelete(state, action: PayloadAction<CarAllocation>) {
      state.allocationId = action.payload.carAllocationId;
      state.goesStraight = action.payload.goesStraight || false;
    },
    clearAllocationIdToDelete(state) {
      state.allocationId = null;
      state.goesStraight = null;
    },
  },
});

export const { registerAllocationIdToDelete, clearAllocationIdToDelete } =
  ConfirmAllocationTaskDeletionSlice.actions;
